// src/components/PostDetails/HtmlContentRenderer.jsx
import React, { useMemo } from 'react'
import { ResponsiveEmbed, PROVIDERS } from '../../TextEditor/nodes/EmbedNode'

export function HtmlContentRenderer({ html }) {
  const parsedContent = useMemo(() => {
    const container = document.createElement('div')
    container.innerHTML = html

    const nodes = []

    Array.from(container.childNodes).forEach((node, idx) => {
      if (
        node.nodeType === 1 &&
        node.tagName === 'IMG' &&
        node.hasAttribute('data-lexical-image')
      ) {
        const src = node.getAttribute('src')
        const alt = node.getAttribute('alt')
        nodes.push(
          <img
            key={`img-${idx}`}
            src={src}
            alt={alt}
            data-lexical-image
            className="block max-w-[70%] w-auto max-h-[500px] my-4 mx-auto"
            loading="lazy"
          />
        )
      } else if (
        node.nodeType === 1 &&
        node.hasAttribute('data-embed-provider') &&
        node.hasAttribute('data-embed-src')
      ) {
        const provider = node.getAttribute('data-embed-provider')
        const src = node.getAttribute('data-embed-src')
        nodes.push(
          <ResponsiveEmbed key={`embed-${idx}`} provider={provider} src={src} />
        )
      } else if (node.nodeType === 1 && node.tagName === 'IFRAME') {
        const src = node.getAttribute('src')
        const provider =
          Object.entries(PROVIDERS).find(([, cfg]) => cfg.re.test(src))?.[0] ||
          'youtube'
        nodes.push(
          <ResponsiveEmbed
            key={`iframe-${idx}`}
            provider={provider}
            src={src}
          />
        )
      } else {
        nodes.push(
          <div
            key={`html-${idx}`}
            dangerouslySetInnerHTML={{ __html: node.outerHTML }}
          />
        )
      }
    })

    return nodes
  }, [html])

  return (
    <div className="post-html-content prose prose-invert break-words whitespace-normal">
      {parsedContent}
    </div>
  )
}
